import IdCell from "layouts/management/members/member-list/components/IdCell";
import DefaultCell from "layouts/management/members/member-list/components/DefaultCell";
import StatusCell from "layouts/management/members/member-list/components/StatusCell";

// Images
import team2 from "assets/images/team-2.jpg";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";

const dataTableData = (list?: any, func?: any, func2?: any, type?: any) => {
  // 비밀글(E)에서는 중요/조회수 컬럼 제외
  const isSecret = type === "E";

  return {
    columns: [
      {
        Header: "Idx",
        accessor: "articleIdx",
        Cell: ({ value }: any) => <DefaultCell value={value} />,
      },
      {
        Header: "카테고리",
        accessor: "category",
        Cell: ({ value }: any) => <DefaultCell value={value} />,
      },
      {
        Header: "제목",
        accessor: "title",
        Cell: ({ value }: any) => <DefaultCell value={value} />,
      },

      {
        Header: "등록일",
        accessor: "writeTime",

        Cell: ({ value }: any) => (
          <DefaultCell value={typeof value === "string" ? value.slice(0, 10) : value} />
        ),
      },
      ...(isSecret
        ? []
        : [
            {
              Header: "중요",
              accessor: "isImportant",
              Cell: ({ value }: any) =>
                value === "Y" ? (
                  <CheckBox color="success" />
                ) : (
                  <CheckBoxOutlineBlank color="disabled" />
                ),
            },
          ]),
      {
        Header: "수정하기",
        accessor: "articleIdx2",
        Cell: ({ value }: any) => (
          <MDButton color="success" onClick={() => func(value)}>
            수정
          </MDButton>
        ),
      },
      {
        Header: "삭제하기",
        accessor: "articleIdx3",
        Cell: ({ value }: any) => (
          <MDButton color="success" onClick={() => func2(value)}>
            삭제
          </MDButton>
        ),
      },
    ],

    rows: !list
      ? [
          {
            id: "#10421",
            writeTime: "1 Nov, 10:20 AM",
            status: "paid",
            customer: ["Orlando Imieto", { image: team2 }],
            product: "Nike Sport V2",
            revenue: "$140,20",
            paymentIdx: "asdsad",
          },
        ]
      : list,
  };
};

export default dataTableData;
